/* eslint-disable complexity */
import { ACCESS_LEVEL } from '~/components/CommonConstants';

export const getFeatureFlagStatus = ({ getFeatureFlags, getTenantByMtCname }, flag) => {
  const { id: tenantId } = getTenantByMtCname;
  if (!tenantId) {
    return false;
  }
  const enabledItem = getFeatureFlags.find(({ name }) => name === flag);
  if (enabledItem) {
    return enabledItem.isEnabledForTenant;
  }
  return false;
};

export const hasPermission = (permissions, permission) =>
  (ACCESS_LEVEL.ALLOW in permissions && permissions[ACCESS_LEVEL.ALLOW].includes(permission)) ||
  (ACCESS_LEVEL.OVERRIDE in permissions && permissions[ACCESS_LEVEL.OVERRIDE].includes(permission));
